module.exports = __webpack_public_path__ + "static/media/发货通知@2x.eaf099f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/发货通知@2x.png
// module id = 1364
// module chunks = 0